import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
const yearlyDiscountPercentage = 0.1;
const stackedLabelRegex = /{\s*([^}]+)\s*}/;
angular
  .module('cxSettings')
  .controller('licenseCtrl', [
    '$scope',
    '$http',
    '$q',
    '$translate',
    'appUrls',
    'flySvc',
    'dialogsSvc',
    'checkSecurity',
    'ModalService',
    '$window',
    '$location',
    'authService',
    'enumCacheSvc',
    'dataCache',
    licenseCtrl,
  ]);

function licenseCtrl(
  $scope,
  $http,
  $q,
  $translate,
  appUrls,
  flySvc,
  dialogsSvc,
  checkSecurity,
  ModalService,
  $window,
  $location,
  authService,
  enumCacheSvc,
  dataCache,
) {
  var vm = this;
  // Block access
  if (!checkSecurity(['CompanyOwn:u', 'Support'])) return;

  $location.search({});

  vm.modules = [];
  vm.nrLicenses = 1;
  vm.minNrLicenses = 1;
  vm.totalAmount = 0;
  vm.promoCode = '';
  vm.billingPeriod = undefined;
  vm.useCredits = false;
  vm.monthlyCredits = 0;
  vm.buyExtraCredits = false;
  vm.monthlyCreditsOptions = [];

  enumCacheSvc.get('tenantbillingperiod').then(function(data) {
    vm.billingPeriods = data;
  });
  var users = dataCache.getArray('user').map(u => ({
    userId: u.userID,
    employeeId: u.employeeID,
    name: `${u.firstName} ${u.lastName}`,
  }));

  vm.hasChanged = function() {
    if (!vm.licenseInformation) return false;
    if (typeof vm.nrLicenses === 'undefined') return false;
    if (vm.nrLicenses !== vm.licenseInformation.totalLicenses) return true;
    if (vm.useCredits !== vm.licenseInformation.useCredits) return true;
    if (vm.monthlyCredits !== vm.licenseInformation.monthlyCredits) return true;
    if (vm.buyExtraCredits !== vm.licenseInformation.buyExtraCredits) return true;
    return false;
  };

  vm.saving = false;

  var mapTmpLicense = l => {
    const { name = null, employeeId = null } =
      (l.userId ? users.find(x => x.userId === l.userId) : null) || {};
    return {
      ...l,
      userName: name,
      employeeId: employeeId,
    };
  };

  vm.paymentInformation = null;
  vm.licenseInformation = null;
  vm.licensePrices = [];
  vm.perRelationPrice = null;
  vm.bucketPrice = null;

  var handleInfoResponse = function(response) {
    if (response.data) {
      vm.licenseInformation = response.data;
      vm.paymentInformation = response.data.paymentInformation;

      vm.perRelationPrice = vm.licenseInformation.perRelationPrice;
      vm.bucketPrice = vm.licenseInformation.bucketPrice;
      vm.nrLicenses = vm.licenseInformation.totalLicenses;
      vm.minNrLicenses =
        vm.licenseInformation.totalLicenses - vm.licenseInformation.availableLicenses;
      vm.useCredits = vm.licenseInformation.useCredits;
      vm.monthlyCredits = vm.licenseInformation.monthlyCredits;
      vm.buyExtraCredits = vm.licenseInformation.buyExtraCredits;

      vm.monthlyCreditsOptions =
        vm.licenseInformation.billCredits && !!vm.licenseInformation.creditPrice
          ? Array.from(
              { length: 10 },
              (_, i) => (i + 1) * vm.licenseInformation.creditPrice.bucketSize,
            )
          : [];

      vm.licensePrices = vm.licenseInformation.prices.map(
        ({ quantityFrom, price, description }) => {
          const values = {};
          if (vm.bucketPrice) {
            values.BucketsQuantityIncluded = '' + vm.bucketPrice.quantityIncluded;
          }

          const label = description.replace(
            stackedLabelRegex,
            (match, p1) => $translate.instant(p1, values) || p1,
          );

          return { quantityFrom, price, label, count: 0 };
        },
      );
      if (vm.perRelationPrice) {
        vm.perRelationPrice.extraQuantity = Math.max(
          vm.licenseInformation.activeRelations - vm.perRelationPrice.quantityIncluded,
          0,
        );
        vm.perRelationPrice.extraAmount =
          Math.round(vm.perRelationPrice.extraQuantity * vm.perRelationPrice.extraPrice * 100) /
          100;
      }
      if (vm.bucketPrice) {
        vm.bucketPrice.nrBuckets = Math.ceil(
          Math.max(0, vm.licenseInformation.activeRelations - vm.bucketPrice.quantityIncluded) /
            vm.bucketPrice.bucketSize,
        );
        vm.bucketPrice.extraQuantity = vm.bucketPrice.nrBuckets * vm.bucketPrice.bucketSize;
        vm.bucketPrice.extraAmount =
          Math.round(vm.bucketPrice.extraQuantity * vm.bucketPrice.pricePerRelation * 100) / 100;

        vm.bucketPrice.baseTranslationValues = {
          Quantity: vm.bucketPrice.quantityIncluded,
        };
        vm.bucketPrice.extraTranslationValues = {
          QuantityIncluded: vm.bucketPrice.quantityIncluded,
          'QuantityIncluded+1': vm.bucketPrice.quantityIncluded + 1,
          Buckets: vm.bucketPrice.nrBuckets,
          BucketSize: vm.bucketPrice.bucketSize,
          Quantity: vm.bucketPrice.extraQuantity,
        };
      }
      vm.billingPeriod =
        vm.licenseInformation.nextBillingPeriod === null
          ? vm.licenseInformation.billingPeriod
          : vm.licenseInformation.nextBillingPeriod;
      vm.discountPercentage = vm.licenseInformation.discount;
      if (vm.licenseInformation.temporaryLicenses)
        vm.licenseInformation.temporaryLicenses = vm.licenseInformation.temporaryLicenses.map(
          mapTmpLicense,
        );

      vm.recalcTotals();
    }
  };
  vm.submit = function(showSuccess = true) {
    if (vm.saving) return;

    if (typeof vm.nrLicenses === 'undefined' || vm.nrLicenses < vm.minNrLicenses) {
      flySvc.warning('msgNumberLicensesLowerThanEmployees');
      return;
    }
    if (vm.useCredits && typeof vm.monthlyCredits === 'undefined') {
      return;
    }
    vm.saving = true;

    return $http
      .put(appUrls.api + '/api/License/UpdateLicenseInformation', {
        nrLicenses: vm.nrLicenses,
        useCredits: vm.useCredits,
        monthlyCredits: vm.monthlyCredits,
        buyExtraCredits: vm.buyExtraCredits,
      })
      .then(
        function(result) {
          if (showSuccess) {
            flySvc.success('msgModuleConfigurationSaved');
          }
          if (result && result.data) {
            handleInfoResponse(result);
          }
          vm.saving = false;
        },
        function(error) {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };
  vm.changeBillingPeriod = function(value) {
    if (vm.saving) return;
    vm.saving = true;

    return $http
      .put(appUrls.api + '/api/License/UpdateBillingPeriod', {
        billingPeriod: value,
      })
      .then(handleInfoResponse, function(error) {
        flySvc.error(error);
        vm.saving = false;
        return '';
      });
  };
  vm.recalcTotals = function() {
    vm.licensePrices.forEach(x => (x.count = 0));
    vm.baseAmount = 0;
    vm.discountAmount = 0;
    if (vm.licenseInformation.billPerLicense && vm.licensePrices.length > 0) {
      const prices = [...vm.licensePrices].sort(dynamicSort('-quantityFrom'));
      for (var i = 1; i <= vm.nrLicenses; i++) {
        const price = prices.find(x => x.quantityFrom <= i);
        price.count += 1;
        vm.baseAmount += price.price;
      }
    }
    if (vm.licenseInformation.billPerRelation && vm.perRelationPrice) {
      const { basePrice, extraAmount } = vm.perRelationPrice;

      vm.baseAmount += basePrice + extraAmount;
    }

    if (vm.licenseInformation.billPerRelationBucket && vm.bucketPrice) {
      const { basePrice, extraAmount } = vm.bucketPrice;
      vm.baseAmount += basePrice + extraAmount;
    }

    if (vm.useCredits && vm.licenseInformation.creditPrice) {
      const { pricePerCredit } = vm.licenseInformation.creditPrice;
      vm.baseAmount += pricePerCredit * (vm.billingPeriod === 0 ? 1 : 12) * vm.monthlyCredits;
    }

    if (vm.discountPercentage > 0) {
      vm.discountAmount = vm.baseAmount * vm.discountPercentage;
      vm.totalAmount = vm.baseAmount - vm.discountAmount;
    } else {
      vm.discountAmount = 0;
      vm.totalAmount = vm.baseAmount;
    }
  };

  vm.reloadLicenseInfo = function() {
    return $http.get(appUrls.api + '/api/License/Info').then(handleInfoResponse, function(error) {
      flySvc.error(error);
    });
  };
  vm.reloadLicenseInfo();

  var activateLicense = function(provider, billingPeriod, promoCode) {
    vm.saving = true;
    return $http.get(appUrls.api + '/api/license/activate/' + billingPeriod + '/' + promoCode).then(
      response => {
        // currently hardcoded because only bank transfers are possible
        var paymentProviderTranslated = $translate.instant('BankTransfer').toLowerCase();

        flySvc.success('msgPaymentProviderChangedSuccess', {
          provider: paymentProviderTranslated,
        });
        vm.saving = false;

        handleInfoResponse(response);
      },
      function(error) {
        flySvc.error(error);
      },
    );
  };

  vm.changePaymentMethod = function(provider) {
    if (vm.saving) return;

    // If no payment info is present, the tenant is setting his payment provider for the first time
    // And a confirmation message should be shown with invoice info
    if (!vm.paymentInformation) {
      return ModalService.showModal({
        template: require('./dialogs/setPaymentProviderConfirmDialog.html'),
        controller: 'SetPaymentProviderConfirmDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          nrLicenses: vm.nrLicenses,
          paymentProvider: provider,
          promoCode: vm.promoCode,
          billingPeriod: vm.billingPeriod,
          totalAmount: vm.totalAmount,
          discountAmount: vm.discountAmount,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e); //Remove event
          modal.element.remove(); //Remove element
        });
        modal.close.then(function(result) {
          if (result) {
            if (vm.hasChanged()) {
              vm.submit(false).then(
                function(result) {
                  activateLicense(provider, vm.billingPeriod, vm.promoCode);
                },
                function(error) {
                  flySvc.error(error);
                },
              );
            } else {
              activateLicense(provider, vm.billingPeriod, vm.promoCode);
            }
          }
        });
      });
    } else {
      dialogsSvc
        .showYesNo('msgConfirmChangePaymentProvidertitle', 'msgConfirmChangePaymentProvider')
        .then(function() {
          activateLicense(provider, vm.billingPeriod, vm.promoCode);
        });
    }
  };

  vm.nrLicensesChanged = function() {
    vm.recalcTotals();
  };

  vm.addTempLicense = function() {
    ModalService.showModal({
      template: require('./dialogs/addTemporaryLicenseDialog.html'),
      controller: 'AddTemporaryLicenseDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        licenseInfo: vm.licenseInformation,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (result) {
          vm.licenseInformation.temporaryLicenses.push(mapTmpLicense(result));
        }
      });
    });
  };

  vm.deleteTempLicense = function(lic) {
    if (!lic || !lic.id || !lic.isNew || lic.userId) return;
    return $http.delete(`${appUrls.api}/api/License/TemporaryLicense/${lic.id}`).then(
      function() {
        const idx = vm.licenseInformation.temporaryLicenses.indexOf(lic);
        if (idx >= 0) {
          vm.licenseInformation.temporaryLicenses.splice(idx, 1);
          flySvc.success();
        }
      },
      function(error) {
        flySvc.error(error);
        return '';
      },
    );
  };

  vm.openCredits = function() {
    ModalService.showModal({
      template: require('./dialogs/tenantCreditDialog.html'),
      controller: 'TenantCreditDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };
}
